// PRO+ hub: the bar only editors see (THE WALL or the band signed in), and THE WALL's PRO+ switch for any band page.
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { PenLine, Images, CalendarPlus, Zap } from "lucide-react";
import { API } from "../../App";
import { auth, errMsg } from "../voltbox/vbShared";
import { HubEditSheet } from "./HubEditSheet";

const GHOST = "inline-flex items-center gap-1.5 rounded-full border border-white/20 px-4 py-2 text-xs font-bold text-white no-underline hover:bg-white/10 transition-colors";

export const HubEditBar = ({ band, as, onSaved }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-10 rounded-2xl border border-[#54E3FF]/40 bg-[#54E3FF]/[0.06] p-4 sm:p-5 flex flex-wrap items-center gap-3" data-testid="hub-edit-bar">
      <PenLine className="h-5 w-5 text-[#54E3FF]" />
      <div className="flex-1 min-w-[200px]">
        <p className="m-0 font-bold text-white" data-testid="hub-edit-as">Editing as {as === "admin" ? "THE WALL" : band.name}</p>
        <p className="m-0 text-xs text-white/55">Only you see this. Words, videos and photos change the moment you save.</p>
      </div>
      <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 rounded-full bg-[#54E3FF] text-[#030608] px-4 py-2 text-xs font-black" data-testid="hub-edit-open"><PenLine className="h-3.5 w-3.5" /> Edit words, videos &amp; links</button>
      <a href="#photos" className={GHOST} data-testid="hub-edit-photos"><Images className="h-3.5 w-3.5" /> Pick photos</a>
      {as === "band" && <Link to="/musician" className={GHOST} data-testid="hub-edit-add-show"><CalendarPlus className="h-3.5 w-3.5" /> Add a show</Link>}
      <HubEditSheet band={band} open={open} onOpenChange={setOpen} onSaved={onSaved} />
    </div>
  );
};

export const HubPlanToggle = ({ slug, on, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const flip = async () => {
    if (on && !window.confirm("Turn the PRO+ hub off? The page goes back to a regular band page (nothing is deleted).")) return;
    setBusy(true);
    try { await axios.put(`${API}/admin/bands/${slug}/hub-plan`, { on: !on }, auth()); toast.success(on ? "PRO+ hub off" : "PRO+ hub on"); onChanged(); }
    catch (e) { toast.error(errMsg(e, "Couldn't change that")); }
    setBusy(false);
  };
  return (
    <button type="button" onClick={flip} disabled={busy} className={`mb-4 inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-black transition-colors disabled:opacity-50 ${on ? "bg-[#54E3FF] text-[#030608]" : "border border-[#54E3FF]/50 text-[#2E5C55] bg-white hover:bg-[#54E3FF]/10"}`} data-testid="hub-plan-toggle" aria-pressed={on}>
      <Zap className="h-3.5 w-3.5" /> PRO+ band hub · {on ? "On" : "Off"} <span className="font-normal opacity-70">(admin)</span>
    </button>
  );
};
